import React, { useState } from 'react'
import Table from '../../../shared/ui/Table'
import { BlackListTableItems } from './BlackListTableItems'
import SearchInput from '../../../shared/ui/SearchInput'
import { useLoad } from '../../../shared/hooks/requests'
import { TENANT_BLACKLIST } from '../../../shared/utils/urls'

const cols = [
    { id: 1, title: 'BlackList Type ID' },
    { id: 2, title: 'CreatedAt' },
    { id: 3, title: 'Tenant ID' },
    { id: 4, title: 'District' },
    { id: 5, title: 'Entity Name' },
    { id: 6, title: 'Region' },
    { id: 7, title: 'UpdatedAt' },
    { id: 8, title: 'Details' },
]

export function BlackListTable() {
    const [page, setPage] = useState(1)
    const [pageSize, setPageSize] = useState(10)
    const loadBlacklists = useLoad({ url: TENANT_BLACKLIST, params: { page, size: pageSize } }, [page, pageSize])
    const blacklist = loadBlacklists.response ? loadBlacklists.response.items : []
    const total = loadBlacklists.response ? loadBlacklists.response.total : 0

    return (
        <div className="w-full flex flex-col items-center gap-[10px]  h-auto bg-white">
            <div className="w-full flex items-center justify-between py-[15px] px-[15px]">
                <span className="text-[16px] font-[500] text-black">BlackList Table</span>
                <SearchInput />
            </div>
            <Table
                page={page + 1}
                rowsPerPage={pageSize}
                loading={loadBlacklists.loading}
                onPageChange={(e, newPage) => setPage(newPage + 1)}
                onRowsPerPageChange={(e) => {
                    setPageSize(parseInt(e.target.value, 10))
                    setPage(1)
                }}
                cols={cols}
                rows={blacklist}
                totalCount={total}
                renderItem={(item) => (
                    <BlackListTableItems
                        key={item.id}
                        item={item}
                    />
                )}
            />
        </div>
    )
}
